/* Product gallery slider: arrows, thumbnails and keyboard. The swipe and counter
   already live in ln-theme.js; this only adds the controls and the active thumbnail. */
(function () {
  function init(root) {
    var track = root.querySelector("[data-gallery-track]");
    if (!track) return;
    var slides = track.children;
    var prev = root.querySelector("[data-gallery-prev]");
    var next = root.querySelector("[data-gallery-next]");
    var thumbs = Array.prototype.slice.call(root.querySelectorAll("[data-gallery-thumb]"));
    var current = 0;
    var target = null;

    function goTo(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      target = i;
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: "smooth" });
    }
    function sync() {
      current = Math.round(track.scrollLeft / track.clientWidth);
      if (target !== null && Math.abs(track.scrollLeft - target * track.clientWidth) < 2) target = null;
      if (prev) prev.disabled = current <= 0;
      if (next) next.disabled = current >= slides.length - 1;
      thumbs.forEach(function (t, i) {
        var on = i === current;
        t.classList.toggle("is-active", on);
        if (on) t.setAttribute("aria-current", "true"); else t.removeAttribute("aria-current");
      });
      var active = thumbs[current];
      if (active && active.parentElement && active.parentElement.parentElement) {
        var bar = active.parentElement.parentElement;
        bar.scrollTo({ left: active.offsetLeft - bar.clientWidth / 2 + active.clientWidth / 2, behavior: "smooth" });
      }
    }

    if (prev) prev.addEventListener("click", function () { goTo((target !== null ? target : current) - 1); });
    if (next) next.addEventListener("click", function () { goTo((target !== null ? target : current) + 1); });
    thumbs.forEach(function (t, i) { t.addEventListener("click", function () { goTo(i); }); });
    track.setAttribute("tabindex", "0");
    track.addEventListener("keydown", function (e) {
      if (e.key === "ArrowRight") { e.preventDefault(); goTo((target !== null ? target : current) + 1); }
      if (e.key === "ArrowLeft") { e.preventDefault(); goTo((target !== null ? target : current) - 1); }
    });
    track.addEventListener("scroll", function () { window.requestAnimationFrame(sync); }, { passive: true });
    sync();
  }
  function boot() { document.querySelectorAll("[data-gallery]").forEach(init); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot); else boot();
})();
